import React from 'react';
import {
  NotificationBadgeStyled,
  BadgeValueStyled,
} from './notificationBadge.styled';

interface BadgeProps {
  children?: React.ReactNode | React.ReactNode[];
  color?: 'success' | 'warning';
  selfContained?: boolean;
  value: number;
  className?: string;
}

const NotificationBadge = ({
  selfContained,
  children,
  color,
  value,
  className,
}: BadgeProps) => {
  if (selfContained) {
    return (
      <BadgeValueStyled
        className={className}
        selfContained={selfContained}
        color={color}
      >
        {value}
      </BadgeValueStyled>
    );
  }

  return (
    <NotificationBadgeStyled className={className}>
      {value > 0 ? (
        <BadgeValueStyled selfContained={selfContained} color={color}>
          {value}
        </BadgeValueStyled>
      ) : null}
      {children}
    </NotificationBadgeStyled>
  );
};

NotificationBadge.defaultProps = {
  selfContained: false,
  value: 0,
};

export default NotificationBadge;
